import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListItem from "../ListItem";
import MenuPage from "../../pages/MenuPage";
import PageNotFound from "../../pages/PageNoteFound";
import RestaurantProfile from "../../pages/RestaurantProfile";
import HomePage from "../../pages/HomePage";
import CartPage from "../../pages/CartPage";
import LoginPage from "../../pages/Login";
import AdminHome from "../../pages/AdminHome";
import Tables from "../../pages/Tables";
import LiveOrder from "../../pages/Tables/LiveOrder";
import Reservation from "../../pages/Reservation/ReservationPage";
import Table from "../../pages/Tables/Table";
import MenuStatus from "../../pages/MenuStatus";
import MenuAlter from "../../pages/MenuAlter";
import FormMenuItem from "../../pages/FormMenuItem";
import RoleManagement from "../../pages/RoleManagement";
import { getLoggedInUser } from "../../redux/api";
import ValidationComp from "./ValidationComp";
import StatusCartPage from "../../pages/StatusCartPage";
import Bills from "../../pages/Bill/index";
import ViewBill from "../../pages/Bill/ViewBill"
import Main from "../../pages/Main";
import CategoriesPage from "../../pages/MenuItem/CategoriesPage";
import FoodsPage from "../../pages/MenuItem/FoodsPage";
import Layout from "../Header/Layout";
import Tax from "../../pages/Setting/Tax";
import RestaurantSetting from "../../pages/Setting/RestaurantSetting"
import TableSetting from "../../pages/Setting/TableSetting";
import QrCodePage from "../../pages/QrCode/QrCodePage";
import Notifications from "../../pages/Notification/Notifications";
import TableBillPage from "../../pages/Tables/TableBillPage";
import BillPage from "../../pages/MenuPage/Bill";
import WaiterRequestPage from "../../pages/WaiterRequest/WaiterRequest";
import OrderHistory from "../../pages/Tables/OrderHistory";
import CancelledOrder from "../../pages/Tables/CancelledOrder";
import Dashboard from "../../pages/Dashboard";
import Reports from "../../pages/Reports";
import ChangePassword from "../Profile/ChangePassword";
import { hasPermission } from "../../Utills/permission";
import { roleMap, packageMap } from "../../Utills/enums"
import ProtectedRoute from "./ProtectedRoute";
import ManageBanners from "../../pages/ManageBanners";
import ManageAddonPage from "../../pages/MenuItem/ManageAddonPage";
import TakeawayCreate from "../../pages/Takeaway/TakeawayCreate";
import TakeawayOrders from "../../pages/Takeaway/TakeawayOrders";
import TakeawaySettings from "../../pages/Takeaway/TakeawaySettings";
import ShiftClosing from "../../pages/ShiftClosing";
import DeviceSettings from "../../pages/Setting/DeviceSettings";
import GeneralSettings from "../../pages/Setting/GeneralSettings";
import SecuritySettings from "../../pages/Setting/SecuritySettings";
import KitchenDisplay from "../../pages/Kds/KitchenDisplay";


function Router() {
    const navigate = useNavigate();
    const user = useSelector((state) => state?.user?.user);
    const userLocal = getLoggedInUser();
    const role = roleMap[user?.roleId];
    const plan = packageMap[user?.packageId];
    if (!(user || userLocal)) {
        return <LoginPage />;
    }

    const PageLayout = (Component) => (
        <Layout>
            <Component />
        </Layout>
    );

    // Router.js ke andar is helper function ko update karein:
const GuardedPage = (Component, featureName) => {
    return (
        <ProtectedRoute feature={featureName}>
            <Layout>
                <Component />
            </Layout>
        </ProtectedRoute>
    );
};

return (
        <Routes>
            <Route path="/" >
                {/* Public / Generic Protected Links */}
                <Route path='' element={PageLayout(Main)} />
                <Route path='change-password' element={PageLayout(ChangePassword)} />
                <Route path='profile' element={<RestaurantProfile />} />
                <Route path='status-cart' element={<StatusCartPage />} />
                <Route path='notification' element={GuardedPage(Notifications, "notification")} />
                

                {/* Home Guarded */}
                <Route path='' element={GuardedPage(Main, "home")} />

                {/* Dashboard Feature */}
                <Route path='dashboard' element={GuardedPage(Dashboard, "dashboard")} />
                <Route path='reports' element={GuardedPage(Reports, "reports")} />
                <Route path='shift-closing' element={GuardedPage(ShiftClosing, "shift-closing")} />

                {/* Menu / Place Order Features */}
                <Route path='menu' element={GuardedPage(MenuPage, "menu")} />
                <Route path="menu-categories" element={GuardedPage(CategoriesPage, "menu")} />
                <Route path="menu-categories/:id/foods" element={GuardedPage(FoodsPage, "menu")} />
                <Route path='menu-status' element={GuardedPage(MenuStatus, "menu")} />
                <Route path='menu-alter' element={GuardedPage(MenuAlter, "menu")} />
                <Route path='menu-edit' element={GuardedPage(FormMenuItem, "menu")} />
                <Route path='manage-banner' element={GuardedPage(ManageBanners, "menu")} />
                <Route path="/manage-addons" element={GuardedPage(ManageAddonPage, "menu")} />

                {/* Table Management / Billing Features */}
                <Route path='tables' element={GuardedPage(Tables, "table")} />
                <Route path="/table/:tableName/:otp" element={PageLayout(Table)} />
                <Route path='/table/:tableName/:otp/cart' element={PageLayout(CartPage)} />
                <Route path='bills' element={GuardedPage(Bills, "bills")} />
                <Route path='bill' element={GuardedPage(BillPage, "bills")} />
                <Route path="/bill/:billId" element={GuardedPage(ViewBill, "bills")} />

                {/* KOT Management Features */}
                <Route path="live-order" element={GuardedPage(LiveOrder, "KOT")} />
                <Route path="kds" element={GuardedPage(KitchenDisplay, "KOT")} />
                <Route path="order-history" element={GuardedPage(OrderHistory, "KOT")} />
                <Route path="order-cancelled" element={GuardedPage(CancelledOrder, "KOT")} />

                {/* Takeaway */}
                <Route path="takeaway/new" element={GuardedPage(TakeawayCreate, "takeaway-create")} />
                <Route path="takeaway/orders" element={GuardedPage(TakeawayOrders, "takeaway-orders")} />
                <Route path="takeaway/history" element={GuardedPage(() => <TakeawayOrders view="history" />, "takeaway-history")} />
                <Route path="takeaway/cancelled" element={GuardedPage(() => <TakeawayOrders view="cancelled" />, "takeaway-cancelled")} />
                <Route path="takeaway/settings" element={<Navigate to="/takeaway-setting" replace />} />

                {/* Settings / Staff Roles Configuration Features */}
                <Route path='user-alter' element={GuardedPage(RoleManagement, "staff")} />
                <Route path='tax-setting' element={GuardedPage(Tax, "tax-setting")} />
                <Route path='restaurant-setting' element={GuardedPage(RestaurantSetting, "restaurant-setting")} />
                <Route path='takeaway-setting' element={GuardedPage(TakeawaySettings, "takeaway-settings")} />
                <Route path='table-setting' element={GuardedPage(TableSetting, "table-setting")} />
                <Route path='general-settings' element={GuardedPage(GeneralSettings, "device-settings")} />
                <Route path='device-settings' element={GuardedPage(DeviceSettings, "device-settings")} />
                <Route path='security-settings' element={GuardedPage(SecuritySettings, "security-settings")} />
                <Route path='qr-code' element={GuardedPage(QrCodePage, "qr-code")} />

                {/* Standalone Dynamic Modules */}
                <Route path='reservation' element={GuardedPage(Reservation, "reservation")} />
                <Route path='waiterRequest' element={GuardedPage(WaiterRequestPage, "waiterRequest")} />
            </Route>

            {/* Error Handlers & Wildcard Structure */}
            <Route path='*' element={<PageNotFound />} />
            <Route path='/:restaurantId/profile' element={<RestaurantProfile />} />
            <Route path='/*' element={<PageNotFound />} />
        </Routes>
    );
}

    // return (
    //     <Routes>
    //         {/* <Route path='/' element={<Main />} /> */}
    //         {/* <Route path='/login' element={<LoginPage />} /> */}
    //         {/* <Route path='/' element={<AdminHome />} /> */}
    //         <Route path="/" >
    //             {/* <Route path="/:restaurantId/:locationId/" element={ValidationComp} > */}
    //             {/* <Route path="/:restaurantId/:locationId/" errorElement={<PageNotFound />} Component={HomePage}> */}
    //             {/* Need to validate path for restaurantId and locationId */}
    //             <Route path='' element={PageLayout(Main)} />
    //             <Route path='menu' element={PageLayout(MenuPage)} />
    //             <Route path='dashboard' element={PageLayout(Dashboard)} />
    //             <Route path='tables' element={PageLayout(Tables)} />
    //             <Route path='bill' element={PageLayout(BillPage)} />
    //             <Route path="/table/:tableName/:otp" element={PageLayout(Table)} />
    //             <Route path="live-order" element={PageLayout(LiveOrder)} />
    //             <Route path="order-history" element={PageLayout(OrderHistory)} />
    //             <Route path="order-cancelled" element={PageLayout(CancelledOrder)} />
    //             <Route path='menu-status' element={PageLayout(MenuStatus)} />
    //             <Route path='menu-alter' element={PageLayout(MenuAlter)} />
    //             <Route path='menu-edit' element={PageLayout(FormMenuItem)} />
    //             <Route path='profile' element={<RestaurantProfile />} />
    //             <Route path='reservation' element={PageLayout(Reservation)} />
    //             <Route path='/table/:tableName/:otp/cart' element={PageLayout(CartPage)} />
    //             <Route path='waiterRequest' element={PageLayout(WaiterRequestPage)} />
    //             <Route path='status-cart' element={<StatusCartPage />} />
    //             <Route path='user-alter' element={PageLayout(RoleManagement)} />

    //             <Route path='change-password' element={PageLayout(ChangePassword)} />
    //             <Route path='bills' element={PageLayout(Bills)} />
    //             <Route path="/bill/:billId" element={PageLayout(ViewBill)} />

    //             <Route path='tax-setting' element={PageLayout(Tax)} />
    //             <Route path='restaurant-setting' element={PageLayout(RestaurantSetting)} />
    //             <Route path='table-setting' element={PageLayout(TableSetting)} />
    //             <Route path='qr-code' element={PageLayout(QrCodePage)} />
    //             <Route path='notification' element={PageLayout(Notifications)} />
    //             <Route path="menu-categories" element={PageLayout(CategoriesPage)} />
    //             <Route path="menu-categories/:id/foods" element={PageLayout(FoodsPage)} />
    //             {/* <Route path='login' element={<LoginPage />} /> */}

    //         </Route>
    //         <Route path='*' element={<PageNotFound />} />
    //         {/* <Route path='/dashboard' element={<Dashboard />} /> */}
    //         {/* Redirect to /:restaurantId/profile */}
    //         {/* <Route path='/:restaurantId' element={<RedirectToProfile />} /> */}
    //         <Route path='/:restaurantId/profile' element={<RestaurantProfile />} />
    //         {/* the /:restaurantId and /:locationId combinedly defines the restaurent of the group*/}
    //         <Route path='/*' element={<PageNotFound />} />
    //         {/* todo: 
    //             <Route path='/:restaurantId/:locationId' element={<RestaurantProfile />} />
    //             <Route path='/:restaurantId' element={<RestaurantGroupProfile />} />
    //              - if above note available - 404 [attractive disgn for "Page Not Found"](With links to navigate other options, including HomePage )

    //                     - This will help in deep linking to a page. 
    //                     - Restaurent owner can directly add the deep link to there official website
    //                     - Or this deep link [maybe, in its short], can be used as SMS or other Marketing strategies
    //         */}
    //         {/* Todo: based on restaurantId and locationId, the MenuPage will fetch the menu Item, name, logo */}
    //         {/* <Route path='/:restaurantId/:categories' element={<MenuPage />} /> */}
    //     </Routes>
    // );
//}

export default Router;
